import { Step, StepLabel, Stepper, Typography } from '@mui/material'

import { IPipelineFunnelResponse } from '../types'

interface IProps {
  data: IPipelineFunnelResponse
}

const fmt = new Intl.NumberFormat('pt-BR')

export function PipelineFunnel({ data }: IProps) {
  return (
    <Stepper alternativeLabel activeStep={data.stages.length - 1}>
      {data.stages.map(stage => (
        <Step key={stage.key} completed>
          <StepLabel>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>{stage.label}</Typography>
            <Typography variant="caption" color="text.secondary">
              {fmt.format(stage.count)}
              {stage.pct_of_previous !== undefined && ` (${stage.pct_of_previous.toFixed(1)}%)`}
            </Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}
